define([
  "backbone",
  "i18n/i18n",
  "marionette",
  "messaging/messenger",
  "configuration/properties",
  "./shareResponseLinkModalView",
  "modules/accountAdmin/apiKeyAdmin/apiKeyModel",
], function (
  Backbone,
  i18next,
  Marionette,
  Messenger,
  Properties,
  ShareResponseLinkModalView,
  ApiKeyModel,
) {
  "use strict";

  const LIVE_CONTENT = "liveContent";
  const WORKING_CONTENT = "workingContent";

  return Marionette.Controller.extend({
    initialize: function ({ region }) {
      this.name = "shareResponseLinkModal";
      this.region = region;
    },
    show: async function ({ languageId, responseTemplateId, topic, touchpointId }) {
      this.languageId = languageId;
      this.responseTemplateId = responseTemplateId;
      this.topic = topic;
      this.touchpointId = touchpointId;

      this.kb = Messenger.reqres.request("active:kb:model");
      await this.kb.onSyncedPromise();
      const responseVersioning = this.kb.get("responseVersioning");

      await this._fetchApiKey();

      const model = new Backbone.Model({
        responseLink: this._buildResponseLink(LIVE_CONTENT),
        topicName: this.topic.get("intentName"),
        showLiveWorkingOptions: responseVersioning,
      });

      this.view = new ShareResponseLinkModalView.shareResponseLinkModalView({ model });
      this.view.on("copy:responseLink", this._onCopyResponseLink, this);
      this.view.on("done", this._onDone, this);
      this.view.on("linkType:live", this._onLinkTypeLive, this);
      this.view.on("linkType:working", this._onLinkTypeWorking, this);

      this.showRegion(this.view);
    },
    _buildResponseLink: function (contentType) {
      const relativeUrl = `${Properties.rootURL}/${this.kb.id}/responseContent/${this.topic.id}/${this.responseTemplateId}/${contentType}?api_key=${this.apiKey}`;
      const fullUrl = new URL(relativeUrl, document.baseURI);
      return fullUrl.href;
    },
    _fetchApiKey: async function () {
      const apiKey = Messenger.reqres.request("apiKey:createPrivate", {
        kb: this.kb,
        languageId: this.languageId,
        roleId: ApiKeyModel.role.ROLE_ENUM.READ_TOPIC_RESPONSE,
        touchpointId: this.touchpointId,
      });
      await apiKey.saveModelPromise();
      this.apiKey = apiKey.get("value");
    },
    _onCopyResponseLink: async function () {
      const responseLink = this.view.getResponseLink();
      try {
        await navigator.clipboard.writeText(responseLink);
        Messenger.okDialog(i18next.t("topic.shareResponseLink.linkCopied"), {
          ok: () => Messenger.vent.trigger("close:modal"),
        });
      } catch (e) {
        console.error("Failed to copy Response link to clipboard", e);
        Messenger.okDialog(i18next.t("topic.shareResponseLink.linkCopyError"));
      }
    },
    _onDone: function () {
      Messenger.vent.trigger("close:modal");
    },
    _onLinkTypeLive: function () {
      const responseLink = this._buildResponseLink(LIVE_CONTENT);
      this.view.model.set("responseLink", responseLink);
      this.view.setResponseLink(responseLink);
    },
    _onLinkTypeWorking: function () {
      const responseLink = this._buildResponseLink(WORKING_CONTENT);
      this.view.model.set("responseLink", responseLink);
      this.view.setResponseLink(responseLink);
    },
  });
});
